import React, { useEffect, useRef, useState, useCallback } from 'react'
import data from '../data.json'

const MOBILE_BREAKPOINT = 768;

export const Lotes = () => {
  const svgContainerRef = useRef(null);
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, lote: null });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  const loadSvg = useCallback((mobile) => {
    const svgFile = mobile ? '/images/ff.svg' : '/images/cuarta.svg';
    const idKey = mobile ? 'svgIdMobile' : 'svgId';

    fetch(svgFile)
      .then((res) => res.text())
      .then((svgText) => {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
        const svgEl = svgDoc.querySelector('svg');

        if (svgEl && svgContainerRef.current) {
          svgEl.setAttribute('width', '100%');
          svgEl.setAttribute('height', '100%');
          svgEl.style.display = 'block';

          // Build a map of svgId -> lote data
          const loteMap = {};
          data.lotes.forEach((l) => {
            if (l[idKey]) {
              loteMap[l[idKey]] = l;
            }
          });

          // Style each path based on data
          const paths = svgEl.querySelectorAll('path');
          paths.forEach((path) => {
            const id = path.getAttribute('id');
            const loteData = loteMap[id];

            if (loteData) {
              if (loteData.status === 'DISPONIBLE') {
                path.style.fill = '#4CAF50';
                path.style.fillOpacity = '0.5';
                path.style.cursor = 'pointer';
                path.classList.add('lote-path', 'lote-disponible');
              } else if (loteData.status === 'VENDIDO') {
                path.style.fill = '#F44336';
                path.style.fillOpacity = '0.5';
                path.style.cursor = 'default';
                path.classList.add('lote-path', 'lote-vendido');
              }

              path.addEventListener('mouseenter', (e) => {
                const rect = svgContainerRef.current.getBoundingClientRect();
                setTooltip({
                  visible: true,
                  x: e.clientX - rect.left,
                  y: e.clientY - rect.top - 10,
                  lote: loteData,
                });
              });

              path.addEventListener('mousemove', (e) => {
                const rect = svgContainerRef.current.getBoundingClientRect();
                setTooltip((prev) => ({
                  ...prev,
                  x: e.clientX - rect.left,
                  y: e.clientY - rect.top - 10,
                }));
              });

              path.addEventListener('mouseleave', () => {
                setTooltip({ visible: false, x: 0, y: 0, lote: null });
              });

              // Touch support for mobile
              path.addEventListener('touchstart', (e) => {
                e.preventDefault();
                const touch = e.touches[0];
                const rect = svgContainerRef.current.getBoundingClientRect();
                setTooltip({
                  visible: true,
                  x: touch.clientX - rect.left,
                  y: touch.clientY - rect.top - 10,
                  lote: loteData,
                });
              }, { passive: false });

              path.addEventListener('touchend', () => {
                setTimeout(() => {
                  setTooltip({ visible: false, x: 0, y: 0, lote: null });
                }, 2000);
              });

              // Click on DISPONIBLE scrolls to cotizador and pre-selects the lote
              if (loteData.status === 'DISPONIBLE') {
                path.addEventListener('click', () => {
                  window.dispatchEvent(new CustomEvent('selectLote', { detail: loteData.lote }));
                  const cotizador = document.getElementById('cotizador-section');
                  if (cotizador) cotizador.scrollIntoView({ behavior: 'smooth' });
                });
              }
            }
          });

          svgContainerRef.current.innerHTML = '';
          svgContainerRef.current.appendChild(svgEl);
        }
      });
  }, []);

  useEffect(() => {
    loadSvg(isMobile);

    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      if (mobile !== isMobile) {
        setIsMobile(mobile);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile, loadSvg]);

  return (
    <div className='container-fluid lotes-container'>
      <div className='svg-wrapper' ref={svgContainerRef}></div>

      {tooltip.visible && tooltip.lote && (
        <div
          className='lote-tooltip'
          style={{ left: tooltip.x, top: tooltip.y }}
        >
          <strong>Lote {tooltip.lote.lote}</strong>
          <span>{tooltip.lote.m2} m² — {tooltip.lote.vista}</span>
          <span>${tooltip.lote.precioTotal.toLocaleString()} MXN</span>
          <span className={`status ${tooltip.lote.status === 'DISPONIBLE' ? 'disponible' : 'vendido'}`}>
            {tooltip.lote.status}
          </span>
        </div>
      )}

      <div className='info-container'>
        <img src="/images/logo_cafe.svg" alt="" />
        <h2>Entrega <br/>2027</h2>
        <a className='button' href="#contacto-section"><img src="/images/amenidades/5.svg" alt="" />Agendar videollamada</a>
      </div>
    </div>
  )
}
